import {
  Button,
  Divider,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalFooter,
  ModalOverlay,
  SimpleGrid,
  Spacer,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useState } from "react";
import { SignupUnit } from "./SignupFlow";
import { Discipline_GET } from "../../../Api/dto/Discipline_GET";

export function VerifySignups(props: {
  startState: SignupUnit[];
  disciplines: Discipline_GET[];
  onNew: () => void;
  onEdit: (signupToEdit: SignupUnit, completedUnits: SignupUnit[]) => void;
  onDelete: (deletedUnit: SignupUnit, signupsToSave: SignupUnit[]) => void;
  onNext: () => void;
}) {
  const [signupUnitToEdit, setSignupUnitToEdit] = useState<
    SignupUnit | undefined
  >();
  const [signupUnitsNotToEdit, setSignupUnitNotToEdit] = useState<SignupUnit[]>(
    []
  );

  console.log("unitedit", signupUnitToEdit);

  return (
    <>
      <VStack spacing={2} alignItems="flex-start">
        <Heading size="md">Översikt</Heading>
        <Text>
          Kontrollera att alla uppgifter stämmer och att du har lagt till alla
          du vill anmäla innan du går vidare till betalningen.
        </Text>
        <Divider></Divider>
        <SimpleGrid autoColumns={"auto"} spacing="20px">
          {props.startState.map((signupUnit, i) => {
            const isTeam = signupUnit.length > 1;
            return (
              <>
                <VStack
                  key={i + "signup_hstack"}
                  background={i % 2 == 0 ? "blue.100" : "gray.100"}
                  width={"100%"}
                  align={"left"}
                  padding={"10px"}
                >
                  <HStack>
                    <Text fontWeight={"bold"}>Klass</Text>
                    <Text>
                      {
                        props.disciplines.find(
                          (d) => d.id == signupUnit[0].disciplineId
                        )?.name
                      }
                    </Text>
                  </HStack>
                  {isTeam && (
                    <HStack>
                      <Text fontWeight="bold">Lagnamn</Text>
                      <Text>{signupUnit[0].groupName}</Text>
                    </HStack>
                  )}
                  <Text fontWeight="bold">Deltagare</Text>
                  <SimpleGrid>
                    {signupUnit
                      .map(
                        (p) =>
                          p.firstname! +
                          "\u00A0" +
                          p.lastname! +
                          " " +
                          (p.fullBirthYear ?? "")
                      )
                      .map((name, i) => (
                        <Text key={"NAME_" + name + i} marginLeft={"10px"}>
                          {name}
                        </Text>
                      ))}
                  </SimpleGrid>
                  <Button
                    variant={"outline"}
                    borderWidth={"2px"}
                    _hover={{ background: "pink.100" }}
                    borderColor={"gray.500"}
                    borderRadius={"10px"}
                    onClick={() => {
                      setSignupUnitToEdit(signupUnit);
                      setSignupUnitNotToEdit(
                        props.startState.filter((u, i2) => i != i2)
                      );
                    }}
                  >
                    Ändra
                  </Button>
                </VStack>
              </>
            );
          })}
        </SimpleGrid>
      </VStack>
      {signupUnitToEdit != null && (
        <VerifyEditModal
          onEdit={() => props.onEdit(signupUnitToEdit, signupUnitsNotToEdit)}
          onDelete={() =>
            props.onDelete(signupUnitToEdit, signupUnitsNotToEdit)
          }
          onClose={() => setSignupUnitToEdit(undefined)}
        />
      )}
      <HStack marginTop={"20px"}>
        <Spacer />
        <Button colorScheme="green" onClick={props.onNew}>
          + Lägg till deltagare
        </Button>
        <Button
          colorScheme="pink"
          isDisabled={props.startState.length == 0}
          onClick={props.onNext}
        >
          Till betalning
        </Button>
        <Spacer />
        <Spacer />
      </HStack>
    </>
  );
}

function VerifyEditModal(props: {
  onEdit: () => void;
  onDelete: () => void;
  onClose: () => void;
}) {
  console.log("Modal");
  return (
    <Modal onClose={props.onClose} size="xl" isOpen={true}>
      <ModalOverlay>
        <ModalBody background={"white"}>
          <Heading size="md">Modifiera anmälan</Heading>
          <Text>
            Här kan du välja om du vill ta bort eller ändra din anmälan.
          </Text>
        </ModalBody>
        <ModalFooter background={"white"}>
          <Button
            marginRight={"10px"}
            colorScheme="red"
            mr={3}
            type="button"
            onClick={() => {
              props.onDelete();
              props.onClose();
            }}
          >
            Ta bort
          </Button>

          <Button
            marginRight={"10px"}
            colorScheme="yellow"
            type="button"
            onClick={() => {
              props.onEdit();
              props.onClose();
            }}
          >
            Ändra
          </Button>
          <Button
            marginRight={"10px"}
            variant="ghost"
            mr={3}
            type="button"
            onClick={() => {
              props.onClose();
            }}
          >
            Avbryt
          </Button>
        </ModalFooter>
      </ModalOverlay>
    </Modal>
  );
}
